import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText } from "vue";
import _imports_0 from './../../assets/image/wechatpay/success.png';
import _imports_1 from './../../assets/image/wechatpay/fail.png';
const _hoisted_1 = {
  class: "point-mall-page"
};
const _hoisted_2 = {
  class: "mid-container"
};
const _hoisted_3 = {
  class: "point-content"
};
const _hoisted_4 = {
  class: "left"
};
const _hoisted_5 = {
  key: 0,
  class: "h5-virtual-list"
};
const _hoisted_6 = {
  class: "h5-none-list"
};
const _hoisted_7 = {
  key: 1,
  class: "h5-virtual-list"
};
const _hoisted_8 = {
  class: "h5-none-list"
};
const _hoisted_9 = {
  class: "right"
};
const _hoisted_10 = {
  key: 0,
  class: "top-block"
};
const _hoisted_11 = {
  class: "top-left-img"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "product-name"
};
const _hoisted_14 = {
  key: 0,
  class: "game-name"
};
const _hoisted_15 = {
  class: "need-points"
};
const _hoisted_16 = {
  key: 1,
  class: "pc-right"
};
const _hoisted_17 = {
  key: 1
};
const _hoisted_18 = ["innerHTML"];
const _hoisted_19 = {
  class: "points-use-detail"
};
const _hoisted_20 = {
  key: 0,
  class: "num"
};
const _hoisted_21 = {
  key: 1,
  class: "num"
};
const _hoisted_22 = {
  class: "can-use"
};
const _hoisted_23 = {
  class: "num"
};
const _hoisted_24 = {
  key: 1,
  class: "can-use"
};
const _hoisted_25 = {
  class: "num"
};
const _hoisted_26 = {
  key: 0
};
const _hoisted_27 = {
  key: 1
};
const _hoisted_28 = {
  key: 2
};
const _hoisted_29 = {
  key: 3
};
const _hoisted_30 = {
  key: 2,
  class: "can-use"
};
const _hoisted_31 = {
  key: 0,
  class: "num"
};
const _hoisted_32 = {
  key: 1,
  class: "num"
};
const _hoisted_33 = {
  class: "can-use"
};
const _hoisted_34 = {
  class: "num"
};
const _hoisted_35 = {
  class: "can-use"
};
const _hoisted_36 = {
  class: "num"
};
const _hoisted_37 = {
  class: "take-out"
};
const _hoisted_38 = {
  class: "num"
};
const _hoisted_39 = {
  class: "choice-role-container"
};
const _hoisted_40 = {
  key: 0
};
const _hoisted_41 = {
  class: "bot-title"
};
const _hoisted_42 = {
  class: "size-list"
};
const _hoisted_43 = ["onClick"];
const _hoisted_44 = {
  key: 0,
  class: "address-detail"
};
const _hoisted_45 = {
  class: "detailed-address"
};
const _hoisted_46 = {
  key: 1,
  class: ""
};
const _hoisted_47 = {
  class: "right-icon"
};
const _hoisted_48 = {
  key: 2,
  class: "none-choice"
};
const _hoisted_49 = {
  key: 3,
  class: "none-choice"
};
const _hoisted_50 = {
  key: 4,
  class: "none-choice"
};
const _hoisted_51 = {
  class: "pc-none-list"
};
const _hoisted_52 = {
  class: "exchange-container"
};
const _hoisted_53 = {
  class: "choice-product-info"
};
const _hoisted_54 = {
  class: "product-img"
};
const _hoisted_55 = ["src"];
const _hoisted_56 = {
  class: "product-info"
};
const _hoisted_57 = {
  class: "product-name"
};
const _hoisted_58 = {
  key: 0,
  class: "game"
};
const _hoisted_59 = {
  class: "need-points"
};
const _hoisted_60 = ["innerHTML"];
const _hoisted_61 = {
  class: "exchange-container"
};
const _hoisted_62 = {
  class: "title-icon"
};
const _hoisted_63 = ["onClick"];
const _hoisted_64 = {
  class: "name-tel"
};
const _hoisted_65 = {
  class: "info-name"
};
const _hoisted_66 = {
  class: "info-tel"
};
const _hoisted_67 = {
  key: 0,
  class: "default-tips"
};
const _hoisted_68 = {
  key: 1,
  class: "now-chioce-tips"
};
const _hoisted_69 = {
  class: "address van-ellipsis"
};
const _hoisted_70 = ["onClick"];
const _hoisted_71 = {
  class: "exchange-container"
};
const _hoisted_72 = {
  class: "address-title"
};
const _hoisted_73 = {
  class: "input-list"
};
const _hoisted_74 = {
  class: "input-list"
};
const _hoisted_75 = {
  class: "input-list"
};
const _hoisted_76 = {
  class: "default-switch"
};
const _hoisted_77 = {
  class: "h5-bot-confrim-container"
};
const _hoisted_78 = {
  class: "h5-bot-body"
};
const _hoisted_79 = {
  class: "choice-product-info progress-bottom"
};
const _hoisted_80 = {
  class: "product-img"
};
const _hoisted_81 = ["src"];
const _hoisted_82 = {
  class: "product-info"
};
const _hoisted_83 = {
  class: "product-name"
};
const _hoisted_84 = {
  key: 0,
  class: "game"
};
const _hoisted_85 = {
  class: "need-points"
};
const _hoisted_86 = {
  key: 1,
  class: "progress-container"
};
const _hoisted_87 = ["innerHTML"];
const _hoisted_88 = {
  class: "top-info"
};
const _hoisted_89 = {
  key: 0,
  class: "right"
};
const _hoisted_90 = {
  class: "info-list"
};
const _hoisted_91 = {
  class: "right"
};
const _hoisted_92 = {
  class: "info-list"
};
const _hoisted_93 = {
  class: "right"
};
const _hoisted_94 = {
  class: "num"
};
const _hoisted_95 = {
  key: 0
};
const _hoisted_96 = {
  key: 1
};
const _hoisted_97 = {
  key: 2
};
const _hoisted_98 = {
  key: 3
};
const _hoisted_99 = {
  class: "info-list"
};
const _hoisted_100 = {
  class: "right"
};
const _hoisted_101 = {
  class: "info-list info-line"
};
const _hoisted_102 = {
  class: "right"
};
const _hoisted_103 = {
  class: "info-list"
};
const _hoisted_104 = {
  class: "right-sec"
};
const _hoisted_105 = {
  key: 0,
  class: "choice-tips"
};
const _hoisted_106 = {
  key: 1,
  class: "choice-tips"
};
const _hoisted_107 = {
  class: "h5-bot-confrim-container"
};
const _hoisted_108 = {
  class: "h5-bot-body"
};
const _hoisted_109 = {
  class: "choice-product-info"
};
const _hoisted_110 = {
  class: "product-img"
};
const _hoisted_111 = ["src"];
const _hoisted_112 = {
  class: "product-info"
};
const _hoisted_113 = {
  class: "product-name"
};
const _hoisted_114 = {
  key: 0,
  class: "game"
};
const _hoisted_115 = {
  class: "need-points"
};
const _hoisted_116 = ["innerHTML"];
const _hoisted_117 = {
  key: 0
};
const _hoisted_118 = {
  class: "chioice-title"
};
const _hoisted_119 = {
  class: "size-list"
};
const _hoisted_120 = ["onClick"];
const _hoisted_121 = {
  class: "top-info"
};
const _hoisted_122 = {
  class: "info-list"
};
const _hoisted_123 = {
  class: "right"
};
const _hoisted_124 = {
  class: "info-list"
};
const _hoisted_125 = {
  key: 0,
  class: "right"
};
const _hoisted_126 = {
  key: 1,
  class: "right"
};
const _hoisted_127 = {
  class: "info-list"
};
const _hoisted_128 = {
  class: "right"
};
const _hoisted_129 = {
  class: "info-list info-line"
};
const _hoisted_130 = {
  class: "right"
};
const _hoisted_131 = {
  class: "info-list"
};
const _hoisted_132 = {
  class: "right-sec"
};
const _hoisted_133 = {
  key: 0,
  class: "address-detail"
};
const _hoisted_134 = {
  class: "address-fir-info"
};
const _hoisted_135 = {
  key: 1
};
const _hoisted_136 = {
  class: "right-icon"
};
const _hoisted_137 = {
  class: "close"
};
const _hoisted_138 = {
  class: "box-container"
};
const _hoisted_139 = {
  class: "nedd-points"
};
const _hoisted_140 = {
  class: "bot-btn-list"
};
const _hoisted_141 = {
  class: "close"
};
const _hoisted_142 = {
  class: "redemption-container"
};
const _hoisted_143 = {
  key: 0,
  class: "title"
};
const _hoisted_144 = {
  key: 1,
  class: "title"
};
const _hoisted_145 = {
  key: 2,
  class: "icon"
};
const _hoisted_146 = {
  key: 3,
  class: "icon"
};
const _hoisted_147 = {
  key: 4,
  class: "tips"
};
const _hoisted_148 = {
  key: 5,
  class: "tips"
};
const _hoisted_149 = {
  key: 6,
  class: "tips"
};
const _hoisted_150 = {
  class: "close"
};
const _hoisted_151 = {
  key: 0,
  class: "address-container"
};
const _hoisted_152 = {
  class: "address-list-body"
};
const _hoisted_153 = ["onClick"];
const _hoisted_154 = {
  class: "name-tel"
};
const _hoisted_155 = {
  class: "info-name"
};
const _hoisted_156 = {
  class: "info-tel"
};
const _hoisted_157 = {
  key: 0,
  class: "default-tips"
};
const _hoisted_158 = {
  key: 1,
  class: "now-chioce-tips"
};
const _hoisted_159 = {
  class: "address van-ellipsis"
};
const _hoisted_160 = ["onClick"];
const _hoisted_161 = {
  key: 1,
  class: "address-container"
};
const _hoisted_162 = {
  class: "address-title"
};
const _hoisted_163 = {
  class: "input-list"
};
const _hoisted_164 = {
  class: "input-list"
};
const _hoisted_165 = {
  class: "input-list"
};
const _hoisted_166 = {
  key: 0
};
const _hoisted_167 = {
  class: "input-list"
};
const _hoisted_168 = {
  class: "default-switch"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ProductList = _resolveComponent("ProductList");
  const _component_van_tab = _resolveComponent("van-tab");
  const _component_van_tabs = _resolveComponent("van-tabs");
  const _component_ProgressBar = _resolveComponent("ProgressBar");
  const _component_van_stepper = _resolveComponent("van-stepper");
  const _component_ArrowRight = _resolveComponent("ArrowRight");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_ArrowLeftBold = _resolveComponent("ArrowLeftBold");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_van_switch = _resolveComponent("van-switch");
  const _component_van_area = _resolveComponent("van-area");
  const _component_el_cascader = _resolveComponent("el-cascader");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: _normalizeClass(["h5-top-choice", [!$setup.mobile ? 'no-login-choice' : '']])
  }, [_createElementVNode("div", {
    class: _normalizeClass(["top-choice", [$setup.nowProductType == 'virtual' ? 'choice-award' : '']]),
    onClick: _cache[0] || (_cache[0] = $event => $setup.changeTab(0))
  }, " 游戏道具兑换 ", 2)], 2), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_van_tabs, {
    active: $setup.active,
    "onUpdate:active": _cache[1] || (_cache[1] = $event => $setup.active = $event),
    shrink: "",
    color: "#8383FF",
    "title-active-color": "#8383FF",
    "title-inactive-color": "#121212",
    sticky: "",
    onChange: $setup.changeTab,
    animated: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_van_tab, {
      title: "游戏道具兑换"
    }, {
      default: _withCtx(() => [_withDirectives(_createVNode(_component_ProductList, {
        type: "virtual",
        detailList: $setup.detailList,
        onChoiceProduct: $setup.choiceProduct
      }, null, 8, ["detailList", "onChoiceProduct"]), [[_vShow, $setup.detailList.length > 0]])]),
      _: 1
    })]),
    _: 1
  }, 8, ["active", "onChange"])]), $setup.nowProductType == 'virtual' && $setup.isMobile() ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_withDirectives(_createVNode(_component_ProductList, {
    type: "virtual",
    detailList: $setup.detailList,
    onChoiceProduct: $setup.hChoiceProduct
  }, null, 8, ["detailList", "onChoiceProduct"]), [[_vShow, $setup.detailList.length > 0]]), _withDirectives(_createElementVNode("div", _hoisted_6, _cache[51] || (_cache[51] = [_createElementVNode("div", null, [_createElementVNode("div", {
    class: "none-list-icon"
  }), _createElementVNode("div", {
    class: "none-list-title"
  }, "暂无相关产品")], -1)]), 512), [[_vShow, $setup.detailList.length == 0]])])) : _createCommentVNode("", true), $setup.nowProductType == 'reality' && $setup.isMobile() ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_withDirectives(_createVNode(_component_ProductList, {
    type: "reality",
    detailList: $setup.detailList,
    onChoiceProduct: $setup.hChoiceProduct
  }, null, 8, ["detailList", "onChoiceProduct"]), [[_vShow, $setup.detailList.length > 0]]), _withDirectives(_createElementVNode("div", _hoisted_8, _cache[52] || (_cache[52] = [_createElementVNode("div", null, [_createElementVNode("div", {
    class: "none-list-icon"
  }), _createElementVNode("div", {
    class: "none-list-title"
  }, "暂无相关产品")], -1)]), 512), [[_vShow, $setup.detailList.length == 0]])])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_9, [_cache[63] || (_cache[63] = _createElementVNode("div", {
    class: "choice-product-title"
  }, "所选物品", -1)), $setup.choiceItem.image_url ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("img", {
    src: $setup.choiceItem.image_url,
    alt: ""
  }, null, 8, _hoisted_12)]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_13, _toDisplayString($setup.choiceItem.name), 1), $setup.tabList.length > 0 && $setup.nowProductType == 'virtual' ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString($setup.tabList[$setup.active].name), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_15, [_createTextVNode(_toDisplayString($setup.choiceItem.points), 1), _cache[53] || (_cache[53] = _createElementVNode("span", null, "积分", -1))]), $setup.choiceItem.limit_type == 6 ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_component_ProgressBar, {
    progressInfo: $setup.choiceItem,
    setWidth: 160,
    setFont: 12
  }, null, 8, ["progressInfo"])])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), _cache[64] || (_cache[64] = _createElementVNode("div", {
    class: "bot-title"
  }, "商品详情", -1)), $setup.choiceItem.describe ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("div", {
    class: "bot-tips",
    innerHTML: $setup.choiceItem.describe
  }, null, 8, _hoisted_18)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_19, [$setup.nowProductType == 'virtual' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "can-use",
    onClick: _cache[2] || (_cache[2] = $event => $setup.showGameRole())
  }, [$setup.choiceRole ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString($setup.choiceSystem) + "-" + _toDisplayString($setup.choiceAread.dist_name) + " . " + _toDisplayString($setup.choiceRole), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_21, "游戏角色")), _cache[54] || (_cache[54] = _createTextVNode()), _cache[55] || (_cache[55] = _createElementVNode("span", null, "充值角色", -1))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_22, [_createElementVNode("span", _hoisted_23, [_createVNode(_component_van_stepper, {
    "disable-input": "",
    modelValue: $setup.exchangeNum,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $setup.exchangeNum = $event),
    modelModifiers: {
      number: true
    },
    min: "0",
    max: $setup.frequency
  }, null, 8, ["modelValue", "max"])]), _cache[56] || (_cache[56] = _createElementVNode("span", null, "兑换物品数量", -1))]), $setup.nowProductType == 'virtual' ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("span", _hoisted_25, [$setup.choiceItem.limit_type != 6 ? (_openBlock(), _createElementBlock("span", _hoisted_26, "每")) : _createCommentVNode("", true), $setup.choiceItem.limit_type == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_27, "天")) : _createCommentVNode("", true), $setup.choiceItem.limit_type == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_28, "周")) : _createCommentVNode("", true), $setup.choiceItem.limit_type == 3 ? (_openBlock(), _createElementBlock("span", _hoisted_29, "月")) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString($setup.choiceItem.stock), 1), _cache[57] || (_cache[57] = _createTextVNode("次 "))]), _cache[58] || (_cache[58] = _createElementVNode("span", null, "道具兑换限制", -1))])) : (_openBlock(), _createElementBlock("div", _hoisted_30, [$setup.choiceItem.limit_quantity > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString($setup.choiceItem.limit_quantity), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_32, "无限制")), _cache[59] || (_cache[59] = _createElementVNode("span", null, "道具兑换限制", -1))])), _createElementVNode("div", _hoisted_33, [_createElementVNode("span", _hoisted_34, _toDisplayString($setup.frequency), 1), _cache[60] || (_cache[60] = _createElementVNode("span", null, "当前可兑换次数", -1))]), _createElementVNode("div", _hoisted_35, [_createElementVNode("span", _hoisted_36, _toDisplayString($setup.pointsNum), 1), _cache[61] || (_cache[61] = _createElementVNode("span", null, "当前可用积分", -1))]), _createElementVNode("div", _hoisted_37, [_createElementVNode("span", _hoisted_38, _toDisplayString($setup.choiceItem.points * $setup.exchangeNum || 0), 1), _cache[62] || (_cache[62] = _createElementVNode("span", null, "本次扣除", -1))])]), _createElementVNode("div", _hoisted_39, [$setup.choiceItem.attr_info && $setup.choiceItem.attr_info.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_40, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.choiceItem.attr_info, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item.id
    }, [_createElementVNode("div", _hoisted_41, _toDisplayString(item.attr_key), 1), _createElementVNode("div", _hoisted_42, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.val_info, subItem => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["size-container", [subItem.choice ? ' size-choice' : '']]),
        key: subItem.id,
        onClick: $event => $setup.choiceRealityType(item.id, subItem.id)
      }, _toDisplayString(subItem.attr_val), 11, _hoisted_43);
    }), 128))])]);
  }), 128))])) : _createCommentVNode("", true), $setup.nowProductType == 'reality' ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "address-container-right",
    onClick: _cache[4] || (_cache[4] = $event => $setup.showAddrssPopup())
  }, [$setup.defaultAddress.address ? (_openBlock(), _createElementBlock("div", _hoisted_44, [_createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString($setup.defaultAddress.consignee), 1), _createTextVNode(_toDisplayString($setup.defaultAddress.phone), 1)]), _createElementVNode("div", _hoisted_45, _toDisplayString($setup.defaultAddress.area) + _toDisplayString($setup.defaultAddress.address), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_46, "点击添加收件信息")), _createElementVNode("div", _hoisted_47, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_ArrowRight)]),
    _: 1
  })])])) : _createCommentVNode("", true), $setup.nowProductType == 'virtual' && !$setup.choiceRole ? (_openBlock(), _createElementBlock("div", _hoisted_48, " *请选择角色 ")) : _createCommentVNode("", true), $setup.nowProductType == 'reality' && !$setup.defaultAddress.address ? (_openBlock(), _createElementBlock("div", _hoisted_49, " *请选择地址 ")) : _createCommentVNode("", true), $setup.nowProductType == 'virtual' && $setup.choiceRole ? (_openBlock(), _createElementBlock("div", _hoisted_50, " 该角色剩余可兑换次数：" + _toDisplayString($setup.frequency), 1)) : _createCommentVNode("", true), _createElementVNode("button", {
    class: "exchange-btn",
    onClick: _cache[5] || (_cache[5] = $event => $setup.showConfirmPopup())
  }, " 确认兑换 ")])], 512), [[_vShow, $setup.detailList.length > 0]])]), _withDirectives(_createElementVNode("div", _hoisted_51, _cache[65] || (_cache[65] = [_createElementVNode("div", null, [_createElementVNode("div", {
    class: "none-list-icon"
  }), _createElementVNode("div", {
    class: "none-list-title"
  }, "暂无相关产品")], -1)]), 512), [[_vShow, $setup.detailList.length == 0]])]), _createVNode(_component_van_popup, {
    show: $setup.exchangePopup,
    "onUpdate:show": _cache[8] || (_cache[8] = $event => $setup.exchangePopup = $event),
    position: "bottom",
    round: ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_52, [_createElementVNode("div", {
      class: "address-title",
      onClick: _cache[6] || (_cache[6] = $event => $setup.exchangePopup = false)
    }, [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_ArrowLeftBold)]),
      _: 1
    }), _cache[66] || (_cache[66] = _createTextVNode("所选物品 "))]), _createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_createElementVNode("img", {
      src: $setup.choiceItem.image_url,
      alt: ""
    }, null, 8, _hoisted_55)]), _createElementVNode("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, _toDisplayString($setup.choiceItem.name), 1), $setup.tabList.length > 0 && $setup.nowProductType == 'virtual' ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString($setup.tabList[$setup.active].name), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_59, [_createElementVNode("span", null, _toDisplayString($setup.choiceItem.points), 1), _cache[67] || (_cache[67] = _createTextVNode("积分 "))])])]), _cache[68] || (_cache[68] = _createElementVNode("div", {
      class: "h5-product-title"
    }, "商品详情", -1)), _createElementVNode("div", {
      class: "h5-product-detail",
      innerHTML: $setup.choiceItem.describe
    }, null, 8, _hoisted_60), _createElementVNode("div", {
      class: "h5-exchange-btn",
      onClick: _cache[7] || (_cache[7] = $event => $setup.hShowExchangePopup())
    }, " 确认兑换 ")])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.hAddressListPopup,
    "onUpdate:show": _cache[11] || (_cache[11] = $event => $setup.hAddressListPopup = $event),
    position: "bottom",
    round: ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_61, [_createElementVNode("div", {
      class: "address-title",
      onClick: _cache[9] || (_cache[9] = $event => $setup.hAddressListPopup = false)
    }, [_createElementVNode("div", _hoisted_62, [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_ArrowLeftBold)]),
      _: 1
    }), _cache[69] || (_cache[69] = _createTextVNode("地址管理 "))])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.addressList, item => {
      return _openBlock(), _createElementBlock("div", {
        class: "top-info-list",
        key: item.id
      }, [_createElementVNode("div", {
        class: "address-detail",
        onClick: $event => $setup.selectAddress(item)
      }, [_createElementVNode("div", _hoisted_64, [_createElementVNode("span", _hoisted_65, _toDisplayString(item.consignee), 1), _createElementVNode("span", _hoisted_66, _toDisplayString(item.phone), 1), item.is_default == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_67, "默认")) : _createCommentVNode("", true), item.id == $setup.defaultAddress.id ? (_openBlock(), _createElementBlock("span", _hoisted_68, "当前选择")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_69, _toDisplayString(item.area) + _toDisplayString(item.address), 1)], 8, _hoisted_63), _createElementVNode("div", {
        class: "editor",
        onClick: $event => $setup.hEditorAddress(item)
      }, "编辑", 8, _hoisted_70)]);
    }), 128)), _createElementVNode("div", {
      class: "h5-exchange-btn address-list-btn",
      onClick: _cache[10] || (_cache[10] = $event => $setup.hEditorAddress())
    }, " 添加地址 ")])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.hAddNewAddressPopup,
    "onUpdate:show": _cache[20] || (_cache[20] = $event => $setup.hAddNewAddressPopup = $event),
    position: "bottom",
    round: ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_71, [_createElementVNode("div", _hoisted_72, [_createElementVNode("div", {
      class: "title-icon",
      onClick: _cache[12] || (_cache[12] = $event => $setup.hAddNewAddressPopup = false)
    }, [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_ArrowLeftBold)]),
      _: 1
    }), _cache[70] || (_cache[70] = _createTextVNode("地址管理 "))]), $setup.addressType == 1 ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "delete-btn",
      onClick: _cache[13] || (_cache[13] = $event => $setup.deleteAddress())
    }, " 删除 ")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_73, [_cache[71] || (_cache[71] = _createElementVNode("div", {
      class: "input-title"
    }, "收货人", -1)), _withDirectives(_createElementVNode("input", {
      placeholder: "请填写收货人姓名",
      type: "text",
      "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $setup.username = $event)
    }, null, 512), [[_vModelText, $setup.username]])]), _createElementVNode("div", _hoisted_74, [_cache[72] || (_cache[72] = _createElementVNode("div", {
      class: "input-title"
    }, "手机号", -1)), _withDirectives(_createElementVNode("input", {
      placeholder: "请填写手机号",
      type: "tel",
      "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $setup.tel = $event)
    }, null, 512), [[_vModelText, $setup.tel]])]), _createElementVNode("div", {
      class: "input-list",
      onClick: _cache[16] || (_cache[16] = $event => $setup.addressListPopup = true)
    }, [_cache[73] || (_cache[73] = _createElementVNode("div", {
      class: "input-title"
    }, "地址选择", -1)), _createElementVNode("div", null, _toDisplayString($setup.provincesList || "请选择省市区"), 1)]), _createElementVNode("div", _hoisted_75, [_cache[74] || (_cache[74] = _createElementVNode("div", {
      class: "input-title"
    }, "详细地址", -1)), _withDirectives(_createElementVNode("input", {
      placeholder: "请填写完整的详细地址",
      type: "text",
      "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => $setup.detailedAddress = $event)
    }, null, 512), [[_vModelText, $setup.detailedAddress]])]), _createElementVNode("div", _hoisted_76, [_cache[75] || (_cache[75] = _createElementVNode("div", null, "设为默认地址", -1)), _createVNode(_component_van_switch, {
      modelValue: $setup.defaultAddressType,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $setup.defaultAddressType = $event),
      "active-color": "#8383FF"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", {
      class: "h5-exchange-btn address-list-btn",
      onClick: _cache[19] || (_cache[19] = $event => $setup.saveAddress())
    }, " 保存 ")])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.addressListPopup,
    "onUpdate:show": _cache[23] || (_cache[23] = $event => $setup.addressListPopup = $event),
    position: "bottom",
    round: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_van_area, {
      title: "选择收货地址",
      "area-list": $setup.areaList,
      modelValue: $setup.nowIndex,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => $setup.nowIndex = $event),
      onConfirm: $setup.confirmSf,
      onCancel: _cache[22] || (_cache[22] = $event => $setup.addressListPopup = false)
    }, null, 8, ["area-list", "modelValue", "onConfirm"])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.hConfirmPopup,
    "onUpdate:show": _cache[28] || (_cache[28] = $event => $setup.hConfirmPopup = $event),
    position: "bottom",
    round: ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_77, [_createElementVNode("div", _hoisted_78, [_createElementVNode("div", _hoisted_79, [_createElementVNode("div", _hoisted_80, [_createElementVNode("img", {
      src: $setup.choiceItem.image_url,
      alt: ""
    }, null, 8, _hoisted_81)]), _createElementVNode("div", _hoisted_82, [_createElementVNode("div", _hoisted_83, _toDisplayString($setup.choiceItem.name), 1), $setup.tabList.length > 0 && $setup.nowProductType == 'virtual' ? (_openBlock(), _createElementBlock("div", _hoisted_84, _toDisplayString($setup.tabList[$setup.active].name), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_85, [_createElementVNode("span", null, _toDisplayString($setup.choiceItem.points), 1), _cache[76] || (_cache[76] = _createTextVNode("积分 "))]), $setup.choiceItem.limit_type == 6 ? (_openBlock(), _createElementBlock("div", _hoisted_86, [_createVNode(_component_ProgressBar, {
      progressInfo: $setup.choiceItem,
      setWidth: $setup.setWidth,
      setFont: 14
    }, null, 8, ["progressInfo", "setWidth"])])) : _createCommentVNode("", true)])]), _cache[84] || (_cache[84] = _createElementVNode("div", {
      class: "h5-product-title"
    }, "商品详情", -1)), _createElementVNode("div", {
      class: "h5-product-detail",
      innerHTML: $setup.choiceItem.describe
    }, null, 8, _hoisted_87), _createElementVNode("div", _hoisted_88, [_createElementVNode("div", {
      class: "info-list",
      onClick: _cache[25] || (_cache[25] = $event => $setup.showGameRole())
    }, [_cache[77] || (_cache[77] = _createElementVNode("div", null, "充值角色", -1)), $setup.nowProductType == 'virtual' && $setup.choiceSystem ? (_openBlock(), _createElementBlock("div", _hoisted_89, _toDisplayString($setup.choiceSystem) + "-" + _toDisplayString($setup.choiceAread.dist_name) + " . " + _toDisplayString($setup.choiceRole), 1)) : _createCommentVNode("", true), $setup.nowProductType == 'virtual' && !$setup.choiceSystem ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "rolename-right",
      onClick: _cache[24] || (_cache[24] = $event => $setup.showGameRole())
    }, " 游戏角色 ")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_90, [_cache[78] || (_cache[78] = _createElementVNode("div", null, "兑换物品数量", -1)), _createElementVNode("div", _hoisted_91, [_createVNode(_component_van_stepper, {
      "disable-input": "",
      modelValue: $setup.exchangeNum,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => $setup.exchangeNum = $event),
      min: "0",
      max: $setup.frequency
    }, null, 8, ["modelValue", "max"])])]), _createElementVNode("div", _hoisted_92, [_cache[80] || (_cache[80] = _createElementVNode("div", null, "道具兑换限制", -1)), _createElementVNode("div", _hoisted_93, [_createElementVNode("span", _hoisted_94, [$setup.choiceItem.limit_type != 6 ? (_openBlock(), _createElementBlock("span", _hoisted_95, "每")) : _createCommentVNode("", true), $setup.choiceItem.limit_type == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_96, "天")) : _createCommentVNode("", true), $setup.choiceItem.limit_type == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_97, "周")) : _createCommentVNode("", true), $setup.choiceItem.limit_type == 3 ? (_openBlock(), _createElementBlock("span", _hoisted_98, "月")) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString($setup.choiceItem.stock), 1), _cache[79] || (_cache[79] = _createTextVNode("次 "))])])]), _createElementVNode("div", _hoisted_99, [_cache[81] || (_cache[81] = _createElementVNode("div", null, "当前可兑换次数", -1)), _createElementVNode("div", _hoisted_100, _toDisplayString($setup.frequency), 1)]), _createElementVNode("div", _hoisted_101, [_cache[82] || (_cache[82] = _createElementVNode("div", null, "当前可用积分", -1)), _createElementVNode("div", _hoisted_102, _toDisplayString($setup.pointsNum), 1)]), _createElementVNode("div", _hoisted_103, [_cache[83] || (_cache[83] = _createElementVNode("div", null, "本次扣除", -1)), _createElementVNode("div", _hoisted_104, _toDisplayString($setup.choiceItem.points * $setup.exchangeNum), 1)])]), $setup.nowProductType == 'virtual' && !$setup.choiceRole ? (_openBlock(), _createElementBlock("div", _hoisted_105, " *请选择角色 ")) : _createCommentVNode("", true), $setup.nowProductType == 'virtual' && $setup.choiceRole ? (_openBlock(), _createElementBlock("div", _hoisted_106, " 该角色剩余可兑换次数：" + _toDisplayString($setup.frequency), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", {
      class: "h5-exchange-btn",
      onClick: _cache[27] || (_cache[27] = $event => $setup.hShowConfirmPopup())
    }, "确认兑换")])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.hPhysicalPopup,
    "onUpdate:show": _cache[32] || (_cache[32] = $event => $setup.hPhysicalPopup = $event),
    position: "bottom",
    round: ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_107, [_createElementVNode("div", _hoisted_108, [_createElementVNode("div", _hoisted_109, [_createElementVNode("div", _hoisted_110, [_createElementVNode("img", {
      src: $setup.choiceItem.image_url,
      alt: ""
    }, null, 8, _hoisted_111)]), _createElementVNode("div", _hoisted_112, [_createElementVNode("div", _hoisted_113, _toDisplayString($setup.choiceItem.name), 1), $setup.tabList.length > 0 && $setup.nowProductType == 'virtual' ? (_openBlock(), _createElementBlock("div", _hoisted_114, _toDisplayString($setup.tabList[$setup.active].name), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_115, [_createElementVNode("span", null, _toDisplayString($setup.choiceItem.points), 1), _cache[85] || (_cache[85] = _createTextVNode("积分 "))])])]), _cache[91] || (_cache[91] = _createElementVNode("div", {
      class: "h5-product-title"
    }, "商品详情", -1)), _createElementVNode("div", {
      class: "h5-product-detail",
      innerHTML: $setup.choiceItem.describe
    }, null, 8, _hoisted_116), $setup.choiceItem.attr_info && $setup.choiceItem.attr_info.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_117, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.choiceItem.attr_info, item => {
      return _openBlock(), _createElementBlock("div", {
        key: item.id
      }, [_createElementVNode("div", _hoisted_118, _toDisplayString(item.attr_key), 1), _createElementVNode("div", _hoisted_119, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.val_info, subItem => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["size-container", [subItem.choice ? ' size-choice' : '']]),
          key: subItem.id,
          onClick: $event => $setup.choiceRealityType(item.id, subItem.id)
        }, _toDisplayString(subItem.attr_val), 11, _hoisted_120);
      }), 128))])]);
    }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_121, [_createElementVNode("div", _hoisted_122, [_cache[86] || (_cache[86] = _createElementVNode("div", null, "兑换物品数量", -1)), _createElementVNode("div", _hoisted_123, [_createVNode(_component_van_stepper, {
      "disable-input": "",
      modelValue: $setup.exchangeNum,
      "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => $setup.exchangeNum = $event),
      min: "0",
      max: $setup.frequency
    }, null, 8, ["modelValue", "max"])])]), _createElementVNode("div", _hoisted_124, [_cache[87] || (_cache[87] = _createElementVNode("div", null, "道具兑换限制", -1)), $setup.choiceItem.limit_quantity > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_125, _toDisplayString($setup.choiceItem.limit_quantity) + "次 ", 1)) : (_openBlock(), _createElementBlock("div", _hoisted_126, "无限制"))]), _createElementVNode("div", _hoisted_127, [_cache[88] || (_cache[88] = _createElementVNode("div", null, "当前可兑换次数", -1)), _createElementVNode("div", _hoisted_128, _toDisplayString($setup.frequency), 1)]), _createElementVNode("div", _hoisted_129, [_cache[89] || (_cache[89] = _createElementVNode("div", null, "当前可用积分", -1)), _createElementVNode("div", _hoisted_130, _toDisplayString($setup.pointsNum || 0), 1)]), _createElementVNode("div", _hoisted_131, [_cache[90] || (_cache[90] = _createElementVNode("div", null, "本次扣除", -1)), _createElementVNode("div", _hoisted_132, _toDisplayString($setup.choiceItem.points * $setup.exchangeNum), 1)])]), _cache[92] || (_cache[92] = _createElementVNode("div", {
      class: "chioice-title"
    }, "收货地址", -1)), _createElementVNode("div", {
      class: "address-container-right",
      onClick: _cache[30] || (_cache[30] = $event => $setup.hShowAddrssPopup())
    }, [$setup.defaultAddress.address ? (_openBlock(), _createElementBlock("div", _hoisted_133, [_createElementVNode("div", _hoisted_134, [_createElementVNode("span", null, _toDisplayString($setup.defaultAddress.consignee), 1), _createTextVNode(_toDisplayString($setup.defaultAddress.phone), 1)]), _createElementVNode("div", null, _toDisplayString($setup.defaultAddress.area) + _toDisplayString($setup.defaultAddress.address), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_135, "点击添加收件信息")), _createElementVNode("div", _hoisted_136, [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_ArrowRight)]),
      _: 1
    })])]), _cache[93] || (_cache[93] = _createElementVNode("div", {
      class: "choice-tips"
    }, "*请确认当前选择的地址", -1))]), _createElementVNode("div", {
      class: "h5-exchange-btn",
      onClick: _cache[31] || (_cache[31] = $event => $setup.hShowConfirmPopup())
    }, "确认兑换")])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.confirmationPopup,
    "onUpdate:show": _cache[36] || (_cache[36] = $event => $setup.confirmationPopup = $event)
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_137, [_createElementVNode("div", {
      class: "close-icon",
      onClick: _cache[33] || (_cache[33] = $event => $setup.confirmationPopup = false)
    })]), _createElementVNode("div", _hoisted_138, [_cache[95] || (_cache[95] = _createElementVNode("div", {
      class: "fir-title"
    }, "确定使用", -1)), _createElementVNode("div", _hoisted_139, [_createElementVNode("span", null, _toDisplayString($setup.choiceItem.points * $setup.exchangeNum), 1), _cache[94] || (_cache[94] = _createTextVNode("积分 "))]), _cache[96] || (_cache[96] = _createElementVNode("div", {
      class: "sec-title"
    }, "兑换该物品吗", -1)), _createElementVNode("div", _hoisted_140, [_createElementVNode("div", {
      class: "cancle",
      onClick: _cache[34] || (_cache[34] = $event => $setup.confirmationPopup = false)
    }, "取消"), _createElementVNode("div", {
      class: "confirm",
      onClick: _cache[35] || (_cache[35] = $event => $setup.confirmBtn())
    }, "确认")])])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.redemptionPopup,
    "onUpdate:show": _cache[39] || (_cache[39] = $event => $setup.redemptionPopup = $event)
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_141, [_createElementVNode("div", {
      class: "close-icon",
      onClick: _cache[37] || (_cache[37] = $event => $setup.redemptionPopup = false)
    })]), _createElementVNode("div", _hoisted_142, [$setup.isSuccess ? (_openBlock(), _createElementBlock("div", _hoisted_143, "兑换成功")) : (_openBlock(), _createElementBlock("div", _hoisted_144, "兑换失败")), $setup.isSuccess ? (_openBlock(), _createElementBlock("div", _hoisted_145, _cache[97] || (_cache[97] = [_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    }, null, -1)]))) : (_openBlock(), _createElementBlock("div", _hoisted_146, _cache[98] || (_cache[98] = [_createElementVNode("img", {
      src: _imports_1,
      alt: ""
    }, null, -1)]))), $setup.isSuccess ? (_openBlock(), _createElementBlock("div", _hoisted_147, "兑换物品具体到账情况请到")) : _createCommentVNode("", true), $setup.isSuccess ? (_openBlock(), _createElementBlock("div", _hoisted_148, "游戏“背包”中进行查看")) : _createCommentVNode("", true), !$setup.isSuccess ? (_openBlock(), _createElementBlock("div", _hoisted_149, _toDisplayString($setup.failTips), 1)) : _createCommentVNode("", true), _createElementVNode("div", {
      class: "record-btn",
      onClick: _cache[38] || (_cache[38] = $event => $setup.goExchangePage())
    }, "查看兑换记录")])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.addressPopup,
    "onUpdate:show": _cache[50] || (_cache[50] = $event => $setup.addressPopup = $event)
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_150, [_createElementVNode("div", {
      class: "close-icon",
      onClick: _cache[40] || (_cache[40] = $event => $setup.closeAddressPopup())
    })]), !$setup.addAddress ? (_openBlock(), _createElementBlock("div", _hoisted_151, [_cache[99] || (_cache[99] = _createElementVNode("div", {
      class: "address-title"
    }, "地址管理", -1)), _createElementVNode("div", _hoisted_152, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.addressList, item => {
      return _openBlock(), _createElementBlock("div", {
        class: "top-info-list",
        key: item.id
      }, [_createElementVNode("div", {
        class: "address-detail",
        onClick: $event => $setup.selectAddress(item)
      }, [_createElementVNode("div", _hoisted_154, [_createElementVNode("span", _hoisted_155, _toDisplayString(item.consignee), 1), _createElementVNode("span", _hoisted_156, _toDisplayString(item.phone), 1), item.is_default == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_157, "默认")) : _createCommentVNode("", true), item.id == $setup.defaultAddress.id ? (_openBlock(), _createElementBlock("span", _hoisted_158, "当前选择")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_159, _toDisplayString(item.area) + _toDisplayString(item.address), 1)], 8, _hoisted_153), _createElementVNode("div", {
        class: "editor",
        onClick: $event => $setup.editorAddress(item)
      }, "编辑", 8, _hoisted_160)]);
    }), 128))]), _createElementVNode("div", {
      class: "add-address-btn",
      onClick: _cache[41] || (_cache[41] = $event => $setup.editorAddress())
    }, "添加地址")])) : (_openBlock(), _createElementBlock("div", _hoisted_161, [_createElementVNode("div", _hoisted_162, [_createElementVNode("div", {
      class: "title-icon",
      onClick: _cache[42] || (_cache[42] = $event => $setup.addressBack())
    }, [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_ArrowLeftBold)]),
      _: 1
    }), _cache[100] || (_cache[100] = _createTextVNode("添加/编辑地址 "))]), $setup.addressType == 1 ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "delete-btn",
      onClick: _cache[43] || (_cache[43] = $event => $setup.deleteAddress())
    }, " 删除 ")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_163, [_cache[101] || (_cache[101] = _createElementVNode("div", {
      class: "input-title"
    }, "收货人", -1)), _withDirectives(_createElementVNode("input", {
      placeholder: "请填写收货人姓名",
      type: "text",
      "onUpdate:modelValue": _cache[44] || (_cache[44] = $event => $setup.username = $event)
    }, null, 512), [[_vModelText, $setup.username]])]), _createElementVNode("div", _hoisted_164, [_cache[102] || (_cache[102] = _createElementVNode("div", {
      class: "input-title"
    }, "手机号", -1)), _withDirectives(_createElementVNode("input", {
      placeholder: "请填写手机号",
      type: "tel",
      "onUpdate:modelValue": _cache[45] || (_cache[45] = $event => $setup.tel = $event)
    }, null, 512), [[_vModelText, $setup.tel]])]), _createElementVNode("div", _hoisted_165, [_cache[103] || (_cache[103] = _createElementVNode("div", {
      class: "input-title"
    }, "地址选择", -1)), _createVNode(_component_el_cascader, {
      options: $setup.regionData,
      modelValue: $setup.selectedOptions,
      "onUpdate:modelValue": _cache[46] || (_cache[46] = $event => $setup.selectedOptions = $event),
      placeholder: "请选择省市区",
      onChange: $setup.handleChange
    }, {
      default: _withCtx(({
        node,
        data
      }) => [_createElementVNode("span", null, _toDisplayString(data.label), 1), !node.isLeaf ? (_openBlock(), _createElementBlock("span", _hoisted_166, " (" + _toDisplayString(data.children.length) + ") ", 1)) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["options", "modelValue", "onChange"])]), _createElementVNode("div", _hoisted_167, [_cache[104] || (_cache[104] = _createElementVNode("div", {
      class: "input-title"
    }, "详细地址", -1)), _withDirectives(_createElementVNode("input", {
      placeholder: "请填写完整的详细地址",
      type: "text",
      "onUpdate:modelValue": _cache[47] || (_cache[47] = $event => $setup.detailedAddress = $event)
    }, null, 512), [[_vModelText, $setup.detailedAddress]])]), _createElementVNode("div", _hoisted_168, [_cache[105] || (_cache[105] = _createElementVNode("div", null, "设为默认地址", -1)), _createVNode(_component_van_switch, {
      modelValue: $setup.defaultAddressType,
      "onUpdate:modelValue": _cache[48] || (_cache[48] = $event => $setup.defaultAddressType = $event),
      "active-color": "#8383FF"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", {
      class: "add-address-btn",
      onClick: _cache[49] || (_cache[49] = $event => $setup.saveAddress())
    }, "保存")]))]),
    _: 1
  }, 8, ["show"])]);
}